<template>
    <div class="main-div">
        <header-delete-account @closeDialog="closeDialog" />
        <main-delete-account @closeDialog="closeDialog" />
    </div>
</template>

<script setup lang="ts">
import { ModalNames } from '~/types/modals';
import HeaderDeleteAccount from './HeaderDeleteAccount.vue';
import MainDeleteAccount from './MainDeleteAccount.vue';

const dialogRef = getDialogRef(ModalNames.DELETE_ACCOUNT);
const closeDialog = () => {
    dialogRef.value.close();
};
</script> 
<style lang="scss" scoped>
.main-div {
    @apply sm:max-w-2xl sm:w-full w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto;
}
</style>